import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SupplierBlendApi } from '../api/supplier-blend.api';
import {
  SupplierBlend,
  SupplierBlendSave,
} from '../models/supplier-blend.model';

@Injectable({ providedIn: 'root' })
export class SupplierBlendService {
  private readonly _api = inject(SupplierBlendApi);

  public getAll(): Observable<SupplierBlend[]> {
    return this._api.getAll();
  }

  public create(data: SupplierBlendSave): Observable<SupplierBlend> {
    return this._api.create(data);
  }

  public update(
    id: string,
    data: SupplierBlendSave,
  ): Observable<SupplierBlend> {
    return this._api.update(id, data);
  }

  public delete(id: string): Observable<void> {
    return this._api.delete(id);
  }

  public setDefault(id: string, isDefault: boolean): Observable<void> {
    return this._api.setDefault(id, isDefault);
  }

  public lockAll(blendIds: string[], isLocked: boolean): Observable<void> {
    return this._api.lockAll(blendIds, isLocked);
  }
}
